import RapidChoiceBase from 'es6/controllers/apps/quizzes/rapid-choice-base';

class ReverseRapidChoicePair extends RapidChoiceBase {
  constructor(itemPackage, ...args) {
    super(itemPackage, ...args);
    this._setQuizType('ReverseRapidChoicePair');
    this._setDistractor(itemPackage.distractors.cue);
    this.recall = 'response';
    this.recallPrompt = itemPackage.getTranslation();
    this.answer = itemPackage.getText();
  }
}

export default ReverseRapidChoicePair;
